export const termsLink = "fkzVKb";
export default {termsLink};